import { IMegaMenuStyle } from '../models/IMegaMenuStyle.js';

/**
 * WHITE LABEL STYLES for MEGA MENU
 */
export const megaMenuStyle: IMegaMenuStyle = {
	children: {
		wrapper: {
			width: '300px',
		},
		button: {
			display: 'flex',
			justifyContent: 'space-between',
			position: 'relative',
			width: '100%',
			background: {
				_value: 'none',
			},
			border: {
				_value: 'none',
				bottom: {
					width: '1px',
					style: 'solid',
					color: '#0075BE',
				},
			},
			padding: {
				_value: '0',
			},
			outline: {
				style: 'none',
			},
			font: {
				size: '13px',
			},
			lineHeight: '40px',
			selectors: {
				':focus': {
					outline: {
						_value: '-webkit-focus-ring-color auto 1px',
					},
				},
			},
		},
		buttonLabel: {
			display: 'block',
			font: {
				weight: 'bold',
			},
			flex: {
				_value: '2',
			},
		},
		heading: {
			display: 'flex',
		},
		clearAllButton: {
			border: {
				_value: 'none',
			},
			background: {
				color: 'transparent',
			},
			cursor: 'pointer',
		},
		menuCheckbox: {
			margin: { _value: '-7px 2px -7px 0' },
			padding: { _value: '0' },
		},
		menuClearButton: {
			background: {
				_value: 'none',
			},
			border: {
				_value: 'none'
			},
			width: '100%',
			padding: {
				_value: '10px 18px',
			},
			text: {
				align: 'left',
			},
			cursor: 'pointer',
			selectors: {
				':hover': {
					background: {
						color: '#efefef',
					},
				},
			},
		},
		menuDescription: {
			font: {
				weight: '300',
				size: '12px',
			},
			max: {
				width: '250px',
			},
		},
		menuDivider: {
			selectors: {
				'.ksys-horizontal': {
					border: {
						_value: 'none',
						top: {
							_value: '1px solid #0075BE',
						},
					},
					margin: {
						_value: '10px 0 0 0',
					},
				},
			},
		},
		menuLabel: {
			font: {
				weight: 'bold',
				size: '14px',
			},
		},
	},
	selectors: {
		' .popper': {
			zIndex: '2',
		},
	},
};
